// extracted by mini-css-extract-plugin
export default {"container":"sectionHeader_container__0z7he","description":"sectionHeader_description__3uCC6"};